import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {SmConfirmationDialogModule} from '../components/sm-confirmation-dialog/sm-confirmation-dialog.module';
import {ServerErrorDialogHostComponent} from './server-error-dialog-host.component';
import {SmBackendRecoveryBannerModule} from '../components/sm-backend-recovery-banner/sm-backend-recovery-banner.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    SmConfirmationDialogModule,
    SmBackendRecoveryBannerModule,
  ],
  declarations: [ServerErrorDialogHostComponent],
  exports: [ServerErrorDialogHostComponent],
})
export class ServerErrorDialogHostModule {}
